import {
  PACKAGE_ID_EVITE_PRO,
  PLAN_NAME_GREETING_CARD_SUBSCRIPTION,
  PLAN_NAME_PARTY_PASS,
  PLAN_NAME_PREMIUM_PASS,
  PLAN_NAME_PREMIUM_PASS_SUBSCRIPTION,
  PLAN_NAME_PRO,
} from '~/common/fabric/routes/EventReview/constants';

export const SUBSCRIPTION_TYPES = {
  pro: PLAN_NAME_PRO,
  evite_pro_yearly: PACKAGE_ID_EVITE_PRO,
  premium_pass: PLAN_NAME_PREMIUM_PASS,
  premium_pass_subscription: PLAN_NAME_PREMIUM_PASS_SUBSCRIPTION,
  greeting_card_subscription: PLAN_NAME_GREETING_CARD_SUBSCRIPTION,
  party_pass: PLAN_NAME_PARTY_PASS,
};

const INVITATION_SUBSCRIPTION_TYPES = {
  pro: PLAN_NAME_PRO,
  evite_pro_yearly: PACKAGE_ID_EVITE_PRO,
  premium_pass: PLAN_NAME_PREMIUM_PASS,
  premium_pass_subscription: PLAN_NAME_PREMIUM_PASS_SUBSCRIPTION,
  party_pass: PLAN_NAME_PARTY_PASS,
};

export const isSubscriptionPlan = (subscriptionPlanName, isGreetingCard) => {
  const types = isGreetingCard ? SUBSCRIPTION_TYPES : INVITATION_SUBSCRIPTION_TYPES;
  return Object.keys(types).includes(subscriptionPlanName);
};
